import { render, staticRenderFns } from "./CustomerFlowList.vue?vue&type=template&id=1baffc17&scoped=true"
import script from "./CustomerFlowList.vue?vue&type=script&lang=js"
export * from "./CustomerFlowList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baffc17",
  null
  
)

export default component.exports